<div class="container u-mt60">
    <div class="row">
        <div class="col-12">
            <div class="breadcrumbs">
                <ul>
                    <li>
                        <a href="">
                            Inicio
                        </a>
                    </li>
                    <li>
                        <a href="">
                            FAQ
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-md-7">
            <h1 class="u-mb10 txt txt--title">
                Solicitudes
            </h1> 
            <a href="" class="back back--small  u-mb20">
                Preguntas Frecuentes
            </a>
        </div>
        <div class="col-md-5">
            <div class="form autocomplete autocomplete--small u-mb20">
                <input type="text" id="iexample" class="form__search" placeholder="Buscar pregunta frecuente">
            </div>
        </div>
        <div class="col-md-12 u-mt70">
            <div class="accordion">
                <a href="" class="accordion__trigger">
                    ¿Quienes y a quienes se pueden solicitar licencia a terceros?
                </a>
                <div class="accordion__content">
                    Las licencias a terceros son gestionadas por el Administrador de Contrato de la persona quien podrá solicitar una licencia hacia otra persona siempre y cuando está sea del mismo contrato.
                </div>
            </div>
            <div class="accordion">
                <a href="" class="accordion__trigger">
                    ¿Quienes y a quienes se pueden solicitar licencia a terceros?
                </a>
                <div class="accordion__content">
                    Las licencias a terceros son gestionadas por el Administrador de Contrato de la persona quien podrá solicitar una licencia hacia otra persona siempre y cuando está sea del mismo contrato.
                </div>
            </div>
            <div class="accordion">
                <a href="" class="accordion__trigger">
                    ¿Quienes y a quienes se pueden solicitar licencia a terceros?
                </a>
                <div class="accordion__content">
                    Las licencias a terceros son gestionadas por el Administrador de Contrato de la persona quien podrá solicitar una licencia hacia otra persona siempre y cuando está sea del mismo contrato.
                </div>
            </div>
            <div class="accordion">
                <a href="" class="accordion__trigger">
                    ¿Quienes y a quienes se pueden solicitar licencia a terceros?
                </a>
                <div class="accordion__content">
                    Las licencias a terceros son gestionadas por el Administrador de Contrato de la persona quien podrá solicitar una licencia hacia otra persona siempre y cuando está sea del mismo contrato.
                </div>
            </div>
            <div class="accordion">
                <a href="" class="accordion__trigger">
                    ¿Quienes y a quienes se pueden solicitar licencia a terceros?
                </a>
                <div class="accordion__content">
                    Las licencias a terceros son gestionadas por el Administrador de Contrato de la persona quien podrá solicitar una licencia hacia otra persona siempre y cuando está sea del mismo contrato.
                </div>
            </div>
        </div>
    </div>
</div>
